import type { MouseEventHandler } from 'react'

export type CmsCtaVariant = 'primary' | 'secondary'

// Injected by the consuming app. When a CTA has trigger_promocode set, clicking
// it fires this callback (e.g. apply promo code + redirect). It receives the
// CTA's url so the app can route after dispatching.
export type OnTriggerPromoCode = (href: string) => void

export type RawCmsCta = {
  text: string
  variant?: CmsCtaVariant
  url?: string
  trigger_promocode?: boolean
}

export type CtaLinkData = {
  text: string
  href: string
  variant?: CmsCtaVariant
  onClick?: MouseEventHandler<HTMLElement>
}

export function mapCmsCta(
  cta?: RawCmsCta,
  onTriggerPromocode?: OnTriggerPromoCode,
): CtaLinkData | undefined {
  if (!cta?.text || !cta.url) {
    return undefined
  }

  const variant = cta.variant ?? 'primary'
  const { url } = cta

  // An explicit url drives navigation; trigger_promocode opts the click into
  // the promo dispatch (apply promo code + redirect).
  return {
    text: cta.text,
    variant,
    href: url,
    onClick:
      cta.trigger_promocode && onTriggerPromocode
        ? (event) => {
            event.preventDefault()
            onTriggerPromocode(url)
          }
        : undefined,
  }
}
